const allProjects = [
  {
    title: 'Kulturan',
    description:
      'This website is made to promote and commersialize the local culture through online media',
    link: '/kulturan',
    livesite: 'https://kulturan.netlify.app/',
    categories: 'current',
  },
  {
    title: 'Medify.id',
    description:
      'This website is made for Medify.id startup that helps medical facilities to record and track medical records electronically',
    link: '/medifyid',
    livesite: 'https://medify.id/',
    categories: 'current',
  },
  {
    title: 'VCF Tools',
    description:
      'This project is to help importing the question from a JSON file',
    link: '/vcf-tools',
    livesite: 'https://vcftools.vercel.app',
    categories: 'ongoing',
  },
  {
    title: 'Presto',
    description:
      "A website that contains list of restaurants with the details, it's my submission on online course at Dicoding Academy",
    link: '/presto',
    livesite: 'https://fwde3faizin.netlify.app',
    categories: 'current',
  },
];

const ongoingProjects = allProjects.filter(
  (item) => item.categories === 'ongoing',
);
const currentProjects = allProjects.filter(
  (item) => item.categories === 'current',
);

export { allProjects, ongoingProjects, currentProjects };
